<i18n>
{
  "en": {
    "eventSearch": "Search by event name",
    "pointOfSale": "Filter by restaurant",
    "eventType": "Filter by event type"
  },
  "es": {
    "eventSearch": "Buscar por nombre de evento",
    "pointOfSale": "Filtrar por restaurante",
    "eventType": "Filtrar por tipo de evento"
  }
}
</i18n>
<template>
  <v-row>
    <v-col class="d-flex mt-lg-4 mt-md-4" cols="12" sm="4" md="3">
      <v-text-field class="pt-0" height="42" :placeholder="$t('eventSearch')" :disabled="disabled" @input="onFinishTyping">
      </v-text-field>
    </v-col>
    <v-col class="d-flex mt-lg-4 mt-md-4" cols="12" sm="4" md="3">
      <v-select v-model="selectedPos" :items="pointOfSaleList" :label="this.$t('pointOfSale')"
                :disabled="disabled" multiple dense hide-details @change="onSelectPos"
                item-value="guid" item-text="name" chips height="42"
      />
    </v-col>
    <v-col class="d-flex mt-lg-4 mt-md-4" cols="12" sm="4" md="3">
      <v-select v-model="selectedType" :items="eventTypeList" :label="this.$t('eventType')"
                :disabled="disabled" multiple dense hide-details @change="onSelectEventType"
                item-value="guid" item-text="name" chips height="42"
      />
    </v-col>
  </v-row>
</template>
<script>
import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';
import { MapGetters } from '@core/helpers/decorators';

@Component
@MapGetters(['pointOfSaleList', 'eventTypeList'])
export default class EventListFilter extends Vue {
  @Prop({ type: Boolean, default: false }) disabled;

  selectedPos = [];

  selectedType = [];

  onSelectPos(emitted) {
    this.$emit('pointOfSale', emitted);
  }

  onSelectEventType(emitted) {
    this.$emit('eventType', emitted);
  }

  onFinishTyping(emitted) {
    this.$emit('eventSearch', emitted);
  }
}
</script>
